<template>
  <div data-app class="md-layout">
    <div class="md-layout-item md-size-100">
      <v-dialog
          v-model="dialog"
          max-width="50%"
      >
        <v-card>
          <v-carousel>
            <v-carousel-item
                v-for="(item,i) in items"
                :key="i"
                :src="item.src_after"
                reverse-transition="fade-transition"
                transition="fade-transition"
            >
              <div :style="{backgroundImage:'url('+item.src_before+')'}" class="before">
              </div>
            </v-carousel-item>
          </v-carousel>
        </v-card>
      </v-dialog>
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-green">
          <h4 class="title">{{local_page_keys.title_page_skills}}</h4>
        </md-card-header>
        <md-card-content>
          <md-table v-if="!is_admin&!loading" v-model="skills" table-header-color="black">
            <md-table-row slot="md-table-row" slot-scope="{ item }" v-if="!empty_base">
              <md-table-cell :md-label="local_page_keys.table_usluga">{{ item[1].russian }}</md-table-cell>
              <md-table-cell :md-label="local_page_keys.table_like">{{ user_skills[item[0] + "_like"] }}</md-table-cell>
              <md-table-cell :md-label="local_page_keys.table_dislike">{{ user_skills[item[0] + "_dislike"] }}</md-table-cell>
              <md-table-cell :md-label="local_page_keys.table_obyasnenie_funkcii">{{ item[1].instruction }}</md-table-cell>
              <md-table-cell :md-label="local_page_keys.table_primery"><a href="#" @click="OpenSlider(item[1].sample)">🔍</a></md-table-cell>
              <md-table-cell :md-label="local_page_keys.table_video_tutorial"><a v-if="item[1].video" :href="item[1].video"
                                                          target="_blank">▶️</a></md-table-cell>
              <md-table-cell :md-label="local_page_keys.table_templeyty"><a v-if="item[1].template" :href="item[1].template"
                                                     target="_blank">📖</a></md-table-cell>
            </md-table-row>
            <md-table-row v-else>
              <span>{{ empty_base_message }}</span>
            </md-table-row>
          </md-table>
          <v-data-table v-if="!loading&is_admin"
                        :headers="headers_admin"
                        :items="admin_data"
                        :footer-props="{
                               'items-per-page-text': local_page_keys.table_pagination_users_on_the_page+':   '
                           }"
          >
          </v-data-table>
          <div v-if="loading">
            <v-progress-circular
                :width="2"
                indeterminate
                style="color: forestgreen"
            ></v-progress-circular>
          </div>
        </md-card-content>
      </md-card>
    </div>

  </div>
</template>

<script>
export default {
  data() {
    return {
      headers_retoucher: [
        {
          text: '',
          align: 'start',
          value: 'user_name'
        },
        {
          text: "",
          align: 'center',
          value: 'order_count'
        },
      ],
      headers_admin: [
        {
          text: '',
          align: 'center',
          value: 'user_name'
        },
        {
          text: "",
          align: 'center',
          value: 'user_likes'
        },
        {
          text: "",
          align: 'center',
          value: 'user_dislikes'
        },
      ],
      dialogVisible: false,
      skills: [],
      user_skills: [],
      dialog: false,
      items: [],
      users_list: [],
      admin_data: [],
      empty_base: false,
      empty_base_message: '',
      loading: true,
      is_admin: false,
      role: '',
      user_login: '',
      local_page_keys: {}
    };
  },
  methods: {


    async getRole() {
      await this.$store.dispatch('profile/role');
      this.role = await this.$store.getters['profile/role'];
    },
    async getPageLocalization(){
      await this.getRole();
      let namePage = 'skills';
      await this.$store.dispatch('localization/pageLocal',{page: namePage});
      this.local_page_keys = await this.$store.getters['localization/pageLocal'];
      if(this.role === 'admin'){
        this.headers_admin[0].text = this.local_page_keys.table_headers_admin_label_login
        this.headers_admin[1].text = this.local_page_keys.table_like
        this.headers_admin[2].text = this.local_page_keys.table_dislike
      }else{
        this.headers_retoucher[0].text = this.local_page_keys.table_usluga
        this.headers_retoucher[1].text = this.local_page_keys.table_headers_retoucher_label_total_number_of_orders
      }
    },
    OpenSlider(img_string) {

      let img_array = img_string.trim().split('https://');
      let new_array = [];

      if (img_array[0] === '') {
        img_array.shift();
      }

      img_array.forEach(function (item, i) {
        if (item.includes('%$-_-$%')) {
          img_array[i] = item.replace('%$-_-$%', '');
        } else if (item.includes('%-_-%')) {
          img_array[i] = item.replace('%-_-%', '');
        }
      });

      img_array.forEach(function (item, i) {
        img_array[i] = item.replace('dl=0', 'raw=1');
      });

      for (let i = 0; i < img_array.length; i += 2) {
        if (img_array[i].includes('before')) {
          new_array.push(
              {
                src_before: 'https://' + img_array[i],
                src_after: 'https://' + img_array[i + 1]
              }
          )
        } else if (img_array[i].includes('after')) {
          new_array.push(
              {
                src_before: 'https://' + img_array[i - 1],
                src_after: 'https://' + img_array[i]
              }
          )
        }

      }
      this.items = new_array;
      this.dialog = true;
    },
    changeUser(selectObj) {
      this.user_skills = [];
      this.skills = [];
      this.fetchSkillsData(selectObj);
      this.fetchUserSkillsData(selectObj);
    },

    async showUsersList() {
      await this.$store.dispatch('skills/usersList');
      const data = await this.$store.getters['skills/usersList'];
      if (data) {
        let users_list = [];
        for (let i = 0; i < data.length; i += 1) {
          users_list.push({
            "text": '<' + data[i].user_email + '>' + ' -  ' + data[i].user_name,
            "value": data[i].user_login,
          });
        }
        this.users_list = users_list;
      } else {
        this.errors = this.local_page_keys.alert_failed_users_list;
      }
      this.classhide = false;
    },
    async getProfile() {
      await this.$store.dispatch('profile/me');
      let user = await this.$store.getters['profile/me'];
      this.user_login = user.login;
    },
    async fetchSkillsData(user_login) {
      try {
        await this.$store.dispatch('skills/userSkillsData', user_login);
        let data = await this.$store.getters['skills/userSkillsData'];
        if (data) {
          this.skills = Object.entries(data);
          if (this.skills[0][0] == 'empty_base') {
            this.empty_base = true;
            this.empty_base_message = this.skills[0][1];
          }
        } else {
          this.errors = this.local_page_keys.alert_failed_admin_skills_data;
        }
      } catch (e) {
        alert(e);
      }
    },
    async fetchUserSkillsData(user_login) {
      try {
        await this.$store.dispatch('skills/userSkills', user_login);
        let data = await this.$store.getters['skills/userSkills'];
        if (data) {
          this.user_skills = data;
        } else {
          this.errors = 'Failed user skills';
        }
      } catch (e) {
        alert(e);
      }
    },
    async fetchAdminSkillsData() {
      try {
        await this.$store.dispatch('skills/adminSkillsData');
        const data = await this.$store.getters['skills/adminSkillsData'];

        if (data) {
          this.admin_data = this.jsonToArray(Object.entries(data));
          this.loading = false;
        } else {
          this.errors = 'Failed adminSkillsData';
        }
      } catch (e) {
        alert(e);
      }
    },
    async adminCheck() {
      await this.getRole();
      await this.getProfile();
      if (this.role === 'admin') {
        this.showUsersList();
        this.is_admin = true;
        this.fetchAdminSkillsData();
      } else {
        this.fetchSkillsData(this.user_login);
        this.fetchUserSkillsData(this.user_login);
        this.loading = false;
      }
    },
    jsonToArray(json) {
      let data = [];
      for (let item of json) {
        data.push(item[1]);
        if (item[1]['empty_base']) {
          this.empty_base = true;
        }
      }
      return data;
    },


  },
  mounted() {
    this.adminCheck();
    this.getPageLocalization();
  }
}
</script>

<style scoped>
.before {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  height: 100%;
  width: 100%;
  background-position: center;
  background-size: cover;
  opacity: 0;
  transition: ease .25s;
}

.before:hover {
  opacity: 1;
  transition: ease .25s;
}

</style>
<style>
.v-window__next {
  right: 0;
}

.v-window__prev {
  left: 0;
}

.v-progress-circular {
  display: block;
  width: 100px;
  margin: 0 auto;
}
</style>